import React from "react";
import {
  Typography
} from "@one-thd/sui-atomic-components";

const OtpLoadingView = (props) => {
  const {
    loadingMessage,
  } = props;

  return (
    <div>
      <div className="sui-h-24 u__medium u__bold u--paddingNormal-bottom">
        <Typography>{loadingMessage}</Typography>
      </div>
      <div className="sui-h-44 sui-flex sui-flex-col sui-items-center sui-justify-items-center">
        <div className="segment-spinner"/>
      </div>
    </div>
  );
};

export default OtpLoadingView;
